(function ($) {
  $.fn.FlowupLabels = function (options) {
    //Local C: version
    var defaults = {
      // Useful if you pre-fill input fields or if localstorage/sessionstorage is used.
      feature_onLoadInit: true,
      // Class names used for focus and populated statuses
      class_focused: 'focused',
      class_populated: 'populated',
    },
      settings = $.extend ({}, defaults, options);

    //console.log ('inside flowuplabels js file on dev');
    return this.each (function () {
      var $scope = $ (this);
      //console.log ($scope);
      $scope
        .on ('focus.flowupLabelsEvt', '.fl_input', function () {
          $ (this).parent ().addClass (settings.class_focused);
        })
        .on ('blur.flowupLabelsEvt', '.fl_input', function () {
          var $this = $ (this);
          $this.val () != null && $this.val ().length > 0
            ? $this
                .parent ()
                .addClass (settings.class_populated)
                .removeClass (settings.class_focused)
            : $this
                .parent ()
                .removeClass (
                  settings.class_populated + ' ' + settings.class_focused
                );
        });

      // On page load, make sure it looks good
      if (settings.feature_onLoadInit) {
        $scope.find ('.fl_input').trigger ('blur.flowupLabelsEvt');
      }
    });
  };
}) (jQuery);



// WEBPACK FOOTER //
// ../../../globalassets/js/jquery.FlowupLabels.js